export default function () {
    if(process.server) return;
    
    window["QueueIt"]?.validateUser(true);
    return;
}